import { useEffect, useContext, useState } from 'react';
import { Card, Container, CardHeader, Typography, Button, CardContent, Grid, Divider, CircularProgress } from '@material-ui/core';
import { LockOpenOutlined as UnLockIcon } from '@material-ui/icons';
import { authContext } from 'helpers/services';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { TextField } from 'formik-material-ui';
import { Link, useLocation } from 'react-router-dom';

let Login = () => {
    let location = useLocation();

    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(false);
    let [returnUrl, setReturnUrl] = useState<string | undefined>();
    let [errors, setError] = useState<string | undefined>();

    let loginSchema = yup.object().shape({
        email: yup.string().default('').required("Email"),
        password: yup.string().default('').required("Password")
    })

    useEffect(() => {
        let prepareReturnUrl = () => {
            if (location.search) {
                let params = new URLSearchParams(location.search);

                let errors = params.get("error");
                if (errors)
                    setError(errors);

                let returnUrl = params.get("returnUrl");
                if (returnUrl)
                    setReturnUrl(returnUrl);
            }

            setLoading(false);
        }

        prepareReturnUrl();
    }, [])


    return (
        <Container maxWidth="md">
            <Card elevation={0}>
                <CardHeader
                    disableTypography
                    title={<Typography variant="h4">Sign in to Videndum Claims</Typography>}
                />

                <CardContent style={{ padding: 0 }}>
                    <Grid container>
                        <Grid item xs>
                            <Grid container>
                                <Grid item xs>
                                    <Typography variant="h5"><b>Videndum Employees Access</b></Typography>
                                </Grid>
                                <Divider style={{ width: '100%' }} />
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<UnLockIcon />}
                                        disabled={isLoading}
                                        onClick={() => authService.federatedSignIn(returnUrl)}
                                    >
                                        Sign In
                                    </Button>
                                    <Typography align="justify" style={{ marginTop: 10, color: '#FF0000' }}>{errors}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="h5"><b>External user access</b></Typography>
                                </Grid>
                                <Divider style={{ width: '100%' }} />
                                <Grid item xs>
                                    <Formik
                                        initialValues={loginSchema.getDefault()}
                                        validationSchema={loginSchema}
                                        onSubmit={async (values, action) => {
                                            setLoading(true);
                                            let res = await authService.signInWithCredentials(values.email, values.password);
                                            if (res === false)
                                                setLoading(false);
                                        }}
                                    >
                                        <Form>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12}>
                                                    <Field
                                                        component={TextField}
                                                        name="email"
                                                        label="Email"
                                                        variant="outlined"
                                                        fullWidth
                                                        type="email"
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Field
                                                        component={TextField}
                                                        name="password"
                                                        label="Password"
                                                        variant="outlined"
                                                        fullWidth
                                                        type="password"
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <Link to="/account/forgotpassword">
                                                        Forgot password
                                                    </Link>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        color="secondary"
                                                        disabled={isLoading}
                                                        startIcon={isLoading ? <CircularProgress size={20} /> : <UnLockIcon />}
                                                    >
                                                        Sign In
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    </Formik>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    );
}

export default Login;